module.exports = __webpack_public_path__ + "static/media/top-nav-bg.84f8970f.jpg";